// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import CovidBath from '../_raw/service/icon_covid_bath.svg';
import withIconProps from '../withIconProps';

export default withIconProps(CovidBath);
